import { useApolloMutation } from "frontend/utils/apolloApi/useApolloMutation.js";

// gql
import { SET_GEM_STATUS_ON_UPLOADS } from "frontend/components/fort/mod/photos/gql/mutations";

// utils
import { useApiUploadUpdate } from "frontend/components/fort/mod/photos/hooks/useApiUploadUpdate.js";

export const useSetFavorite = () => {
    const { apiUploadUpdate } = useApiUploadUpdate();

    const { apolloMutate } = useApolloMutation({
        actionDesc: "Upload: Set Favorite",
        gql: SET_GEM_STATUS_ON_UPLOADS
    });

    const setFavorite = async ({ photoUploadIds, isActivated }) => {
        const { ssResp } = await apolloMutate({
            variables: {
                photoUploadIds: photoUploadIds,
                value: isActivated
            }
        });

        apiUploadUpdate(ssResp);
    };

    return {
        setFavorite
    };
};
